import { paletteHelper, typographyHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { ContentBrick } from '../../../app-kit/components/ContentBrick/ContentBrick';
import { usePropertyPageQuery } from '../../graphql/usePropertyPageQuery';
import { mapDynamicContentItems } from '../../../app-kit/components/DynamicContent/helpers/mapDynamicContentItem';
import {
  DynamicContents,
  DynamicContentsItem,
} from '../../../app-kit/components/DynamicContent/types';
import { DynamicContent } from '../../../app-kit/components/DynamicContent/DynamicContent';
import { StyledProptrackLogoBrickSource } from '../../../components/ProptrackLogoBrickSource/ProptrackLogoBrickSource';

const Description = styled.div`
  color: ${paletteHelper('textPrimary')};
  ${typographyHelper('body01')}
  margin-top: -0.5rem;
`;

interface PropertyDescriptionBrickProps {
  title: string;
  description: DynamicContents<DynamicContentsItem>;
}

const PropertyDescriptionBrick: FunctionComponent<PropertyDescriptionBrickProps> = ({
  title,
  description,
}) => {
  return (
    <ContentBrick title={title}>
      <Description>
        <DynamicContent dynamicContents={description} />
      </Description>
      <StyledProptrackLogoBrickSource />
    </ContentBrick>
  );
};

export const PropertyDescriptionBrickWithData: FunctionComponent = () => {
  const data = usePropertyPageQuery()?.data.propertyPageBySlugV3;
  if (!data?.propertyDescriptionV2) return null;

  const { title, description } = data.propertyDescriptionV2;

  return (
    <PropertyDescriptionBrick title={title} description={mapDynamicContentItems(description)} />
  );
};
